<div
  class="canvas-page"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
  (contextmenu)="$event.preventDefault()"
>
  <!-- Diagram fills entire canvas -->
  <div class="canvas-diagram-layer">
    <ddc-canvas-diagram
      [canvasData]="selectedCanvasData"
      [isRunning]="isRunning"
      [isTraceMode]="!!selectedTrace"
      [nodeResults]="nodeResults"
      (diagramChanged)="onDiagramChanged()"
      (modelReady)="onModelReady()"
    />
  </div>

  <!-- Floating vertical toolbar (top-left) -->
  <div class="canvas-floating-toolbar">
    <ddc-canvas-toolbar
      [canRedo]="diagramComponent?.canRedo ?? false"
      [canUndo]="diagramComponent?.canUndo ?? false"
      [canvasId]="selectedCanvas?.id ?? null"
      [canvasTitle]="selectedCanvas?.title ?? ''"
      [getCanvasData]="getCanvasData"
      [hasUnsavedChanges]="selectedCanvas ? dirtyCanvasIds.has(selectedCanvas.id) : false"
      [isSaving]="isSaving"
      (addItem)="onAddItem()"
      (commandExecuted)="onToolbarCommandExecuted($event)"
      (redo)="onRedo()"
      (toggleSidebar)="toggleSidebar()"
      (undo)="onUndo()"
    />
  </div>

  <!-- Floating sidebar (between toolbar and title) -->
  @if (isSidebarOpen) {
    <div class="canvas-floating-sidebar" (click)="onSidebarInteraction()">
      <ddc-canvas-sidebar
        [canvases]="canvases"
        [dirtyCanvasIds]="dirtyCanvasIds"
        [editingCanvasId]="editingCanvasId"
        [isLoading]="isLoading"
        [isLoadingTraces]="isLoadingTraces"
        [selectedCanvasId]="selectedCanvas?.id ?? null"
        [selectedTraceId]="selectedTrace?.id ?? null"
        [traces]="traces"
        (clearTrace)="onClearTrace()"
        (createCanvas)="onCreateCanvas()"
        (deleteAllTraces)="onDeleteAllTraces()"
        (deleteCanvas)="onDeleteCanvasFromSidebar($event)"
        (deleteTrace)="onDeleteTrace($event)"
        (duplicateCanvas)="onDuplicateCanvas($event)"
        (refreshList)="loadCanvases()"
        (renameCanvas)="onRenameCanvas($event)"
        (selectCanvas)="onSelectCanvas($event)"
        (selectTrace)="onSelectTrace($event)"
      />
    </div>
  }

  <!-- Floating selected canvas title + run toolbar -->
  @if (selectedCanvas) {
    <div
      class="canvas-floating-title-row"
      [class.sidebar-expanded]="isSidebarOpen && selectedCanvas"
      [class.sidebar-open]="isSidebarOpen"
    >
      <div class="canvas-floating-title">
        <mat-icon class="canvas-icon">dashboard</mat-icon>
        <span class="canvas-path">{{ selectedCanvas?.title ?? 'Canvas' }}</span>
        @if (selectedCanvas && dirtyCanvasIds.has(selectedCanvas.id)) {
          <span class="unsaved-dot" matTooltip="Unsaved changes"></span>
        }
      </div>

      <ddc-canvas-management-toolbar
        [canRun]="canRunCanvas"
        [canvasId]="selectedCanvas?.id ?? null"
        [isRunning]="isRunning"
        [isTraceMode]="!!selectedTrace"
        (clearTrace)="onClearTrace()"
        (exitTrace)="onExitTrace()"
        (runCanvas)="onRunCanvas()"
      />
    </div>
  }
</div>
